

import Vue from 'vue'
import FastClick from 'fastclick'
import router from './router'
import App from './App'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import LightTimeline from 'vue-light-timeline'

FastClick.attach(document.body)
Vue.use(LightTimeline)
Vue.config.productionTip = false

import AlertPlugin from 'vux/src/plugins/alert/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'

Vue.use(AlertPlugin)
Vue.use(LoadingPlugin)
Vue.use(ConfirmPlugin)
Vue.use(ToastPlugin)


Vue.prototype.$msgbox = function (title, msg) {
this.$vux.alert.show({
title: title,
content: msg,
buttonText: "确定",
});
}

Vue.prototype.$msgloading = function (text, time) {
this.$vux.loading.show({
text: text
})
setTimeout(() => {
this.$vux.loading.hide()
}, time)
}

Vue.prototype.$msgtoast = function (text, time = 800, type = 'text', position = 'middle', width = '150px') {
this.$vux.toast.show({
text: text,
type: type,
time: time,
isshowmask: false,
position: position,
width: '170px',
});
}
Vue.use(iView);
/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js